import { useEffect } from "react";
import { useNavigate } from "react-router";
import Login from "./pages/LoginForm/Login/Login";

export default function UnauthenticatedContent() {
	const navigate = useNavigate();

	// Limpieza de la ruta al hacer logout
	useEffect(() => {
		navigate("/");
	}, []);

	return <Login />;
}
